const updatedReportName = (str) => str.toLowerCase().charAt(0).toUpperCase() + str.slice(1).toLowerCase()

export default updatedReportName